import React from "react";
import css from "./Footer.module.css";
import { Link } from "react-router-dom";
import logo from "./logo.png";

import crystals from "../../images/crystals.png";

const Footer = ({ background }) => {
  return (
    <div
      className={css.container}
      style={{ background: background ? "#f0ecff" : "" }}
    >
      <img className="crystals" src={crystals} alt="crystals" />

      <div className={css.background}>
        <div className={css.main}>
          <nav className={css.links}>
            <Link className={css.link} to="/bookkeeping">
              Bookkeeping
            </Link>
            <Link className={css.link} to="/consulting">
              Consulting
            </Link>
            <Link className={css.link} to="/payroll">
              Payroll
            </Link>
            <Link className={css.link} to="/registration">
              Registration
            </Link>
            <Link className={css.link} to="/contact">
              Contact
            </Link>
          </nav>
          <Link to="/" style={{ padding: 0 }}>
            <img
              className={css.logo}
              src={logo}
              alt="crystal clear consulting logo"
            />
          </Link>
          <div className="flex">
            <Link className={css.link} to="/privacy">
              Privacy Policy
            </Link>
            <p className={css.copyright}>© 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
